import { PageTemplate } from '../../components/PageTemplate';
import { TermTemplate } from './TermTemplate';

const SLUG = 'termos-de-uso';

export const TermsOfUse = () => {
  return (
    <PageTemplate title="Termos e condições de uso">
      <TermTemplate slug={SLUG} />
    </PageTemplate>
  );
};
